<div class="container-fluid--">
  <ng-http-loader *ngIf="showLoader == true" [filteredHeaders]="['X-Special-Param']"></ng-http-loader>
  <router-outlet></router-outlet>
  
  <!-- <button *ngIf="!hideChatButton" (click)="onChatButtonClick()" style="     border-radius: 50px;
  /* width: 200px; */
  height: 50px;
  padding: 0px 15px;
  top: 99vh;
  right: 10px;
  position: fixed;
  z-index: 1000;
  border: 0px;
  background-color: #e01b1b;
  color: #ffffff;
  transform: rotate(180deg) translateX(100%);
  transform-origin: right top;
  ">
  <div style="font-size: 22px;
    transform: rotate(-180deg);"><i class="fa-solid fa-comment"></i></div>
</button> -->
</div>
